export default function ContactlessPaymentIcon({
  width = 24,
  height = 24,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fill="#232D34"
        d="M14.41 6.253a.77.77 0 0 0-1.358.724 10.672 10.672 0 0 1 0 10.046.77.77 0 0 0 1.357.724 12.211 12.211 0 0 0 0-11.494ZM9.025 9.33a.77.77 0 1 0-1.358.724 4.134 4.134 0 0 1 0 3.892.77.77 0 1 0 1.358.724 5.673 5.673 0 0 0 0-5.34Z"
      />
      <path
        fill="#232D34"
        d="M10.677 7.475a.77.77 0 0 1 1.04.317 8.943 8.943 0 0 1 0 8.416.77.77 0 1 1-1.357-.724 7.404 7.404 0 0 0 0-6.968.77.77 0 0 1 .317-1.04Z"
      />
      <path
        fill="#232D34"
        fillRule="evenodd"
        d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2ZM3.538 12a8.462 8.462 0 1 1 16.924 0 8.462 8.462 0 0 1-16.924 0Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
